import Assets from "./assets.vue";
import InnoDescription from "../innovadis/inno-description.vue";
import InnoProperties from "../innovadis/inno-properties.vue";
import InnoDownloads from "../innovadis/inno-downloads.vue";
import Variations from "./variations.vue";
import Videos from "./videos.vue";
import type { Component } from "vue";

const templateBlocks: { [key: string]: Component } = {
  "product-assets": Assets,
  "product-description": InnoDescription,
  "product-properties": InnoProperties,
  "product-variations": Variations,
  "product-downloads": InnoDownloads,
  "product-videos": Videos,
};

export default templateBlocks;
